export function renderBuildSortLabelExprSortDirectionTemplate(): string {
  return `const sortDirection = column.getIsSorted()
      const sortLabel = sortDirection === 'asc'
        ? 'sorted ascending'
        : sortDirection === 'desc'
        ? 'sorted descending'
        : 'not sorted'
`
}
